import { useMutation } from '@tanstack/react-query';
import {
  submitApplication,
  type PublicApplicationType,
  type SubmitApplicationInput,
} from '../api/applications.public.api';

/**
 * Submit the public Apply-form for the given entity type (MYN-80, FR-140).
 * `type` is fixed per page (Investors today, Trusted Partner once MYN-215/216
 * ships its own page), not chosen by the form itself.
 */
export function useSubmitApplication(type: PublicApplicationType) {
  return useMutation({
    mutationFn: (input: SubmitApplicationInput) => submitApplication(type, input),
  });
}
